<template>
  <div>
    <slot :open-file-picker="openFilePicker">
      <button class="btn btn-success" type="button" @click="openFilePicker">
        {{ $t('Choose files') }}
      </button>
    </slot>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <FilepickerInputField
      v-if="useInputField"
      class="m-t-10"
      :input-name="inputName"
      :selected-files="inputSelectedFiles"
    />
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <ProvideApiFilebank
      v-slot="{ loading, uploadFiles, uploading, fileData }"
      :use-global-id="useGlobalId"
      :default-tags="defaultTags"
      :exclude-ids="excludeIds"
      @initial-files-loaded="updateAutoSelectedFiles"
      @uploaded="handleRecentlyUploadedFiles"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseModal
        :save-state="uploading ? 'saving' : 'fresh'"
        :is-open="isOpen"
        :header-text="$t('Your Worksome files')"
        data-test="filebank-select-and-add-button"
        :confirm-button-text="
          $t('Select and add') + ` ${selectedFileCount ? '(' + selectedFileCount + ')' : ''}`
        "
        :saving-text="$t('Uploading') + '...'"
        :no-top-margin="noTopMargin"
        :modal-id="randomModalId"
        @positive-response="emitSelection"
        @cancel="isOpen = false"
      >
        <template #topright>
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <PickerFileOs
            :multiple="true"
            :disabled="uploading"
            button-class="btn btn-success"
            data-test="filebank-upload-files"
            @files-selected="uploadFiles"
          >
            <template v-if="uploading">
              <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
              <button-spinner />
              {{ $t('Uploading') }}
            </template>
            <template v-else>
              <i class="fa fa-upload" />
              {{ $t('Upload file') }}
            </template>
          </PickerFileOs>
        </template>

        <template #default>
          <div style="max-height: 500px; overflow-y: auto">
            <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
            <BaseSelectableFileList
              ref="fileList"
              :exclude-ids="excludeIds"
              :files="fileData"
              :is-loading="loading"
              :auto-select="autoSelect"
              :use-global-id="useGlobalId"
              @selection-updated="handleFileSelection"
            />
          </div>
        </template>
      </BaseModal>
    </ProvideApiFilebank>
  </div>
</template>

<script>
/**
 * Exclude - array of file ID's to exclude
 */
import { isIterable } from '@/utils/tools'
import ProvideApiFilebank from '@/components/ProvideApiFilebank.vue'

export default {
  components: [ProvideApiFilebank],
  props: {
    preSelectedFiles: { type: Array, default: () => [] },
    excludeIds: { type: Array, default: () => [] },
    noTopMargin: { type: Boolean, default: false },
    defaultTags: { type: Array[String], default: () => [] },
    useInputField: { type: Boolean, default: false },
    inputName: { type: String, default: 'uploadfiles[]' },
    useGlobalId: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedFiles: [],
      inputSelectedFiles: [],
      uploadedFiles: [],
      isOpen: false,
      autoSelect: this.getInitialAutoSelectedFiles(),
    }
  },
  computed: {
    idProp() {
      return this.useGlobalId ? 'globalId' : 'localId'
    },
    selectedFileCount() {
      return this.selectedFiles.length
    },
    randomModalId() {
      // Generate a random ID for the modal - otherwise we cannot have multiple instances on the same page.
      return `picker-file-filebank-${Math.random().toString(36).slice(-5)}`
    },
  },
  methods: {
    openFilePicker() {
      this.isOpen = true
    },
    handleFileSelection(selection) {
      this.selectedFiles = selection.map((file) => ({
        ...file,
        id: file[this.idProp],
      }))
    },
    emitSelection() {
      if (this.useInputField) {
        this.inputSelectedFiles = this.selectedFiles
      }
      this.$emit('files-selected', this.selectedFiles)
      this.isOpen = false
      this.$refs.fileList.uncheckAllFiles()
    },
    /**
     * this is to populate the input value with pre-selected files
     * since we only have a list of id's, we need to wait for the api to return the account's files
     * so we can collect the file objects represented by the preSelectedFiles array of id's
     * @param files
     */
    updateAutoSelectedFiles(files) {
      if (isIterable(this.preSelectedFiles) && isIterable(files)) {
        this.selectedFiles = [
          ...this.selectedFiles,
          ...files.filter((file) => this.preSelectedFiles.includes(file[this.idProp])),
        ]
      }
      if (this.useInputField) {
        this.inputSelectedFiles = this.selectedFiles
      }
    },
    getInitialAutoSelectedFiles() {
      return this.preSelectedFiles
    },
    handleRecentlyUploadedFiles(files) {
      this.autoSelect = files.map((file) => file[this.idProp])
    },
  },
}
</script>
